<template>
  <div id="app">
    <!-- keepAliveList 是需要缓存页面的组件名数组 -->
    <!-- <keep-alive include="index,order,photo-order">
      <router-view  />
    </keep-alive> -->
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
  window.onload = function(){
    document.addEventListener('touchstart',function(e){
      if(e.touches.length > 1){
        event.preventDefault()
      }
    })
    document.addEventListener('gesturestart',function(e){
      e.preventDefault()
    })
  }
import "./libs/rem.js";
import './static/fonts/iconfont.css'
import './assets/fonts/font.css'
export default {
  name: 'app',
  data(){
    return{
    }
  },
  computed:{
    keepAliveList(){
      return this.$store.getters.keepAliveList
    }
  }
}
</script>
<style>
html,body{
  height: 100%;
}
#app {
  /* font-family: 'PingFangM'; */
  font-family: 'SimSun';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* 在浮动元素的父元素加这个class 清楚浮动带来的影响  start */
.clearfix:after{
     content:".";        
     display:block;        
     height:0;        
     clear:both;        
     visibility:hidden;        

}
.clearfix{zoom:1}
/* 在浮动元素的父元素加这个class 清楚浮动带来的影响  end */

.scorll::-webkit-scrollbar { /*滚动条整体样式*/
    width: 0px !important;; /*高宽分别对应横竖滚动条的尺寸*/
    height: 0px !important;;
    background: #f2f2f2 !important;;
    cursor: pointer !important;

}
.scorll::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 5px !important;
    -webkit-box-shadow: inset 0 0 5px rgba(240, 240, 240, .5) !important;;
    background: rgba(63, 98, 131, 0.8) !important;;
    cursor: pointer !important;
}
.scorll::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(240, 240, 240, .5) !important;;
    border-radius: 0 !important;;
    background: rgba(240, 240, 240, 0.5) !important;;
    cursor: pointer !important;
}
.gray-bg{
  background: #F7F7F7;
  position: absolute;
  z-index: 0;
  width: 100%;
  min-height: 100%;
}
.flex{
  display: flex;align-items: center
}
.goBack{
  font-size: 1rem;color: #505050;
}

/*包含以下五种的链接*/
a {
    text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
    text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
    text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
    text-decoration: none;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
    text-decoration: none;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
    text-decoration: none;
}
</style>
